import { useEffect, useState } from 'react'

export const DESKTOP_QUERY = '(min-width: 768px)'
// Tailwind's `lg`, where the app switches to its desktop layout.
export const WIDE_QUERY = '(min-width: 1024px)'

function matches(query: string): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.(query).matches
}

export function useMediaQuery(query: string): boolean {
  const [value, setValue] = useState(() => matches(query))
  useEffect(() => {
    const list = window.matchMedia?.(query)
    if (!list) return
    const onChange = () => setValue(list.matches)
    list.addEventListener?.('change', onChange)
    return () => list.removeEventListener?.('change', onChange)
  }, [query])
  return value
}
